export default "__VITE_ASSET__Bpez82hS__"